










































































import {Component, Vue} from "vue-property-decorator";
import {MetadataBackup} from "@/assets/ts/MetadataBackup";

import ExecutionResult = MetadataBackup.Response.ExecutionResult;
import VideoListResult = MetadataBackup.Response.VideoListResult;
import {Utils} from "@/assets/ts/Utils";
import VideoMetadata = MetadataBackup.Response.VideoMetadata;

@Component
export default class SearchResultModal extends Vue {
  private show = false;
  public showModal(): void { this.show = true; }
  public hideModal(): void { this.show = false; }
  public toggleModal(): void { this.show = !this.show; }

  private response: VideoListResult | null = null;
  set Response(value: ExecutionResult<VideoListResult>) {
    this.response = value.response;
  }

  UnixTimestampToDateString = Utils.UnixTimestampToDateString

  exportAsCsv(): void {
    this.exportCsvNoRecord();
    this.exportCsvRetrieved();
  }
  exportCsvRetrieved(): void {
    const rows = [];
    // write csv headers
    // @ts-ignore
    if (!this.response?.videos[0])
      return;
    rows.push(Object.keys(this.response?.videos[0]).join(","));

    this.response?.videos.forEach((e: VideoMetadata) => {
      const l = [];
      // @ts-ignore
      for (const key of Object.keys(e)) {
        // @ts-ignore
        const val = e[key];
        // For some reason, we can't directly access val.replace because val.replace is not a function,
        // so we gotta convert it to string first, then replace, then push to the list
        // Also, about escaping quotes in csv:
        // https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv
        // Also, We didn't escape "\" , etc, because i am too lazy
        const tmp = `${val}`.replace(/"/g, `""`).replace(/'/g, `''`);
        l.push(`"${tmp}"`);
      }
      rows.push(l.join(",").replace(/(\r\n|\r|\n)/g, "\\n"));
    });

    let csv = rows.join("\n");
    Utils.ExportFile([csv], "export_data.csv", {type: "text/csv"});
  }
  exportCsvNoRecord(): void {
    const rows = ["videoId"];
    if (!this.response?.noRecord)
      return;

    rows.push(...this.response?.noRecord);
    let csvData = rows.join("\r\n");
    Utils.ExportFile([csvData], "export_no_record.csv", {type: "text/csv"});
  }

  exportAsJson(): void {
    Utils.ExportFile([JSON.stringify(this.response)], "export.json", {type: "application/json"});
  }
}
